import { Tile, NUM_TILE_TYPES } from '../tiles';
import { toCounts } from '../hand';
import { shanten } from '../shanten';

export function shantenOf(tiles: readonly Tile[]): number {
  return shanten(toCounts(tiles));
}

/** 더하면 샹텐이 줄어드는 타일 종류 수(이미 4장 보유한 종류는 제외). */
export function ukeireCount(hand13: readonly Tile[]): number {
  const counts = toCounts(hand13);
  const base = shanten(counts);
  let n = 0;
  for (let t = 0; t < NUM_TILE_TYPES; t++) {
    if (counts[t] >= 4) continue;
    counts[t]++;
    if (shanten(counts) < base) n++;
    counts[t]--;
  }
  return n;
}

export interface DiscardEval {
  tile: Tile;
  shanten: number;
  ukeire: number;
}

/** 14장에서 버릴 최선의 패. 샹텐 최소 → 우케이레 최대 → 타일 번호 최소. */
export function bestDiscard(hand14: readonly Tile[]): DiscardEval {
  const distinct = Array.from(new Set(hand14)).sort((a, b) => a - b);
  let best: DiscardEval | null = null;
  for (const tile of distinct) {
    const rest = removeOne(hand14, tile);
    const sh = shantenOf(rest);
    const uk = ukeireCount(rest);
    const cand: DiscardEval = { tile, shanten: sh, ukeire: uk };
    if (best === null || isBetterDiscard(cand, best)) best = cand;
  }
  return best as DiscardEval;
}

function isBetterDiscard(a: DiscardEval, b: DiscardEval): boolean {
  if (a.shanten !== b.shanten) return a.shanten < b.shanten;
  if (a.ukeire !== b.ukeire) return a.ukeire > b.ukeire;
  return a.tile < b.tile;
}

function removeOne(tiles: readonly Tile[], tile: Tile): Tile[] {
  const out = tiles.slice();
  const i = out.indexOf(tile);
  if (i !== -1) out.splice(i, 1);
  return out;
}
